<template>
    <section id="loyalty" class="loyalty">
        <div class="ob-arc loyalty-arc-1" />
        <div class="ob-arc loyalty-arc-2" />
        <div class="loyalty-head">
            <div class="loyalty-soon"><span class="loyalty-soon-dot" />Coming soon</div>
            <h2 class="loyalty-h2">Loyalty programme</h2>
            <p class="loyalty-p">Two memberships. Staying with us should be worth something.</p>
        </div>

        <div class="loyalty-grid">
            <div>
                <div class="ob-cardstage loyalty-stage">
                    <div class="ob-card3d loyalty-card">
                        <div class="ob-cardface loyalty-face-blue">
                            <img src="/assets/card-blue-front.webp" alt="One Blue membership card" loading="lazy" width="800" height="518">
                        </div>
                    </div>
                </div>
                <div class="loyalty-card-info">
                    <div class="loyalty-card-k">One Pro customers only</div>
                    <p class="loyalty-card-p">One Blue will be available to One Pro customers at launch. Other tiers will not be eligible.</p>
                </div>
            </div>
            <div>
                <div class="ob-cardstage loyalty-stage">
                    <div class="ob-card3d loyalty-card loyalty-card-offset">
                        <div class="ob-cardface loyalty-face-black">
                            <img src="/assets/card-black-front.webp" alt="One Black membership card" loading="lazy" width="800" height="518">
                        </div>
                    </div>
                </div>
                <div class="loyalty-card-info">
                    <div class="loyalty-card-k">Business customers</div>
                    <p class="loyalty-card-p">One Black is being designed for our business customers. Details to follow.</p>
                </div>
            </div>
        </div>

        <div class="loyalty-cta-row">
            <a href="#contact" class="loyalty-cta ob-press">Tell me when it launches →</a>
        </div>
    </section>
</template>

<style scoped>
    .loyalty { position: relative; max-width: 1240px; margin: 0 auto; padding: 0 44px 96px; }
    .loyalty-arc-1 { position: absolute; left: 50%; top: 120px; width: 520px; height: 520px; margin-left: -260px; opacity: .6; pointer-events: none; }
    .loyalty-arc-2 { position: absolute; left: 50%; top: 210px; width: 340px; height: 340px; margin-left: -170px; opacity: .5; pointer-events: none; }
    .loyalty-head { text-align: center; max-width: 640px; margin: 0 auto; }
    .loyalty-soon {
        display: inline-flex;
        align-items: center;
        gap: 9px;
        padding: 7px 15px;
        border-radius: 999px;
        background: var(--ob-blue-a10);
        border: 1px solid var(--ob-blue-a28);
        font-size: 11.5px;
        font-weight: 700;
        letter-spacing: .14em;
        text-transform: uppercase;
        color: var(--ob-blue-deep);
    }
    .loyalty-soon-dot { width: 7px; height: 7px; border-radius: 50%; background: var(--ob-blue); }
    .loyalty-h2 {
        margin: 22px 0 0;
        font-size: clamp(32px, 4.4vw, 58px);
        font-weight: 800;
        letter-spacing: -.032em;
        line-height: 1;
        color: var(--ob-ink);
    }
    .loyalty-p { margin: 16px auto 0; max-width: 460px; font-size: 17px; line-height: 1.6; color: var(--ob-ink-soft); }

    .loyalty-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 40px; margin-top: 56px; align-items: start; }
    .loyalty-stage { width: 100%; max-width: 400px; margin: 0 auto; }
    .loyalty-card { width: 100%; aspect-ratio: 1.544; }
    .loyalty-card-offset { animation-delay: -4.5s; }
    .loyalty-face-blue { box-shadow: var(--ob-shadow-card-blue); }
    .loyalty-face-black { box-shadow: var(--ob-shadow-card-black); }
    .ob-cardface img { width: 100%; height: 100%; display: block; object-fit: cover; }

    .loyalty-card-info { margin-top: 26px; text-align: center; }
    .loyalty-card-k { font-size: 13px; font-weight: 700; letter-spacing: .14em; text-transform: uppercase; color: var(--ob-blue-deep); }
    .loyalty-card-p { margin: 10px auto 0; max-width: 340px; font-size: 15px; line-height: 1.55; color: var(--ob-ink-sub); }

    .loyalty-cta-row { text-align: center; margin-top: 48px; }
    .loyalty-cta {
        display: inline-flex;
        align-items: center;
        gap: 9px;
        background: var(--ob-blue);
        color: var(--ob-white);
        font-weight: 700;
        font-size: 15.5px;
        padding: 17px 32px;
        border-radius: 999px;
        box-shadow: var(--ob-shadow-glow);
        white-space: nowrap;
        text-decoration: none;
    }

    @media (max-width: 800px) {
        .loyalty-grid { grid-template-columns: 1fr; gap: 48px; }
    }
    @media (max-width: 700px) {
        .loyalty { padding: 0 20px 64px; }
        .loyalty-grid { margin-top: 40px; }
        .loyalty-stage { max-width: 320px; }
    }
</style>
